import { SVGProps } from "react";

type DoubleLineMenuProps = SVGProps<SVGSVGElement>;

export const DoubleArrowIcon = (props: DoubleLineMenuProps) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
    >
      <path
        d="M20.5 21.1985L15.5 16.1985L20.5 11.1985"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 21.1985L10.5 16.1985L15.5 11.1985"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
